import { createContext, useContext } from 'react';

import type { LuminaSubAgentResponseType } from './types';

interface LuminaSubAgentContextType {
	luminaSubAgentResponse: LuminaSubAgentResponseType[];
}

export const LuminaSubAgentContext = createContext<LuminaSubAgentContextType>({
	luminaSubAgentResponse: [],
});

export const useLuminaSubAgentContext = () => useContext(LuminaSubAgentContext);
